<template lang="pug">
.dawn-card
  .dawn-card-top
    slot(name='top')
    span.close-icon(v-if='!hasSlotTop' @click='removecard')
      i.fal.fa-times
  .dawn-card-header
    span.dawn-card-header-icon(v-if='icon')
      i(:class='iconClass')
    span.dawn-card-header-title
      p.title
        slot(name='title')
        span(v-if='!hasSlotTitle') {{ title }}
      p.subtitle(v-if='subtitle') {{ subtitle }}
  .dawn-card-body
    slot(name='body')
  .dawn-card-footer.text-right
    slot(name='footer')
    div(v-if='!hasSlotFooter')
      ed-button.btn.btn-actionbar(@click='edit', v-if='footerButton != "false" && !href') {{ footerButton }}
      ed-button.btn.btn-actionbar(@click='edit', v-if='footerButton != "false" && !!href' :href='href') {{ footerButton }}
</template>

<script>
export default {
  name: 'ed-card',
  props: {
    id: {
      type: Number,
      default: 1
    },
    title: {
      type: String
    },
    subtitle: String,
    footerButton: {
      type: String,
      default: 'Edit'
    },
    icon: Array,
    href: String
  },
  computed: {
    hasSlotTop () {
      return this.$slots.top
    },
    hasSlotTitle () {
      return this.$slots.title
    },
    hasSlotFooter () {
      return this.$slots.footer
    },
    iconClass () {
      return this.icon[0] + ' fa-' + this.icon[1]
    }
  },
  methods: {
    removecard: function () {
      var id = this.id
      this.$emit('removecard', id)
    },
    edit: function () {
      var id = this.id
      this.$emit('edit', id)
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-card {
  float: left;
  width: 280px;
  margin: 0rem 1.5rem 1.5rem 0rem;
  padding: .75rem .65rem .0rem .65rem;
  box-shadow: $box-shadow;
  background-color: $canvas;
  border-color: $background;
  transition: all .3s ease;

  p.title {
    font-weight: $font-weight-bold;
    font-size: $font-size-base;
    color: $primary-05;
    margin-bottom: .5em;
  }

  p.subtitle {
    font-size: $font-size-xsmall;
    line-height: 1.2;
    min-height: 2.5rem;
  }

  .dawn-card-header {
    display: flex;
    flex-direction: row;
    -webkit-flex-direction: row;
  }

  .dawn-card-header-icon {
    display: inline-block;
    font-size: 1.5rem;
    color: $ink;
    padding: 0rem .5rem 0rem 0rem;

    i {
      vertical-align: top;
    }
  }

  .dawn-card-header-title {
    display: inline-block;
  }
}

.dawn-card-top {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -20px;

  span.close-icon {
    font-weight: 100;
    color: $ink;
    margin-left: 2rem;
    &:hover {
      cursor: pointer;
    }
  }

  .form-group {
    margin-bottom: -5px;
  }
}

.dawn-card-body p {
  font-size: $font-size-medium;
  margin-bottom: 0;
}

.dawn-card-enter {
  opacity: 0;
}

.dawn-card-leave-active {
  opacity: 0;
}

.dawn-card-enter .dawn-card-container,
.dawn-card-leave-active .dawn-card-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.dawn-card-footer {
  min-height: 3rem;
  .btn {
    text-decoration: none;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?31a760af